import { render, staticRenderFns } from "./EditCompare.vue?vue&type=template&id=6845b21c&"
import script from "./EditCompare.vue?vue&type=script&lang=js&"
export * from "./EditCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports